$(function () {
	const searchButtons = $('.site-search__button');
	const searchOverlay = $('.search-overlay');
	const searchInput = document.querySelector('.js-suggest-search-results');
	const searchSuggestions = document.getElementById('searchsuggestions');

	const debounce = (fn, ms = 0) => {
		let timeoutId;

		return function (...args) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => fn.apply(this, args), ms);
		};
	};

	if (searchButtons && searchOverlay) {
		const root = document.querySelector(':root');
		const headerHeight = $('header').height();
		root.style.setProperty('--header-height', headerHeight + 'px');

		$(searchButtons).each(function () {
			$(this).on('click', function () {
				$('body').toggleClass('search-open');
				$('[role=banner]').toggleClass('search-open');
			})
		});
	}

	if (searchInput && searchSuggestions) {

		searchInput.addEventListener('input', debounce(() => {

			let apiUrl = `/api/searchsuggestions?query=${encodeURIComponent(searchInput.value)}`;

			fetch(apiUrl)
				.then(response => response.text())
				.then(html => {
					searchSuggestions.innerHTML = html;
				})
				.catch(error => console.error('Error fetching search suggestions:', error));

		}, 300));
	}
});